export default __webpack_public_path__ + "static/media/footer.ccc3c7b0.webp";